import { render } from "./rcsPreview.vue?vue&type=template&id=4b75b15c&scoped=true"
import script from "./rcsPreview.vue?vue&type=script&lang=js"
export * from "./rcsPreview.vue?vue&type=script&lang=js"

import "./rcsPreview.vue?vue&type=style&index=0&id=4b75b15c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b75b15c"]])

export default __exports__